import axios from "axios";
import { saveFile, openFile, openBlankTab } from "../../../native/files";

// Base client for /api/accounting/*. Every module keeps its own endpoints in its folder's
// api.js and imports `request` from here so auth and error shape stay in one place.
const base = `${process.env.REACT_APP_BACKEND_URL}/accounting`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });

export const request = {
  get: (path, params) => axios.get(`${base}${path}`, { ...headers(), params }),
  post: (path, body) => axios.post(`${base}${path}`, body, headers()),
  put: (path, body) => axios.put(`${base}${path}`, body, headers()),
  del: path => axios.delete(`${base}${path}`, headers()),
  blob: (path, params) => axios.get(`${base}${path}`, { ...headers(), params, responseType: "blob" }),
  upload: (path, formData) => axios.post(`${base}${path}`, formData, headers())
};

export const getSettings = () => request.get("/settings");
export const updateSettings = body => request.put("/settings", body);

export const listAccounts = params => request.get("/ledger/accounts", params);
export const createAccount = body => request.post("/ledger/accounts", body);
export const updateAccount = (id, body) => request.put(`/ledger/accounts/${id}`, body);
export const accountSheet = (number, params) => request.get(`/ledger/accounts/${number}/sheet`, params);
export const listEntries = body => request.post("/ledger/entries/list", body);
export const createEntry = body => request.post("/ledger/entries", body);
export const getEntry = id => request.get(`/ledger/entries/${id}`);
export const updateEntry = (id, body) => request.put(`/ledger/entries/${id}`, body);
export const reverseEntry = (id, body) => request.post(`/ledger/entries/${id}/reverse`, body);
export const listPeriods = year => request.get("/ledger/periods", { year });
export const closePeriod = period => request.post(`/ledger/periods/${period}/close`);
export const reopenPeriod = period => request.post(`/ledger/periods/${period}/reopen`);
export const trialBalance = params => request.get("/ledger/trial-balance", params);
export const auditTrail = (collection, id) => request.get(`/ledger/audit/${collection}/${id}`);

/** Error text from an axios error, for message.error(). */
export const errorText = (error, fallback = "Something went wrong") =>
  error?.response?.data?.errorMessage || error?.message || fallback;

/** Opens a blob response in a new tab (PDF, XML), keeping the auth header. */
export const openBlob = async (promise, filename) => {
  const tab = filename ? null : openBlankTab();
  try {
    const res = await promise;
    if (filename) await saveFile(res.data, filename);
    else await openFile(res.data, { tab });
  } catch (err) {
    tab?.close();
    throw err;
  }
};
